import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {Prescription} from '../Prescription.ts';
import {PrescriptionApi} from '../../../apis/PrescriptionApi/PrescriptionApi.ts';

export function useDeletePrescription() {
    const queryClient = useQueryClient();

    return useMutation<string, AppMedError, string>({
        mutationKey: [QueryKeys.prescription],
        mutationFn: async (id: string) => {
            await PrescriptionApi.deletePrescription(id);
            return id;
        },
        onSuccess: async (id: string) => {
            queryClient.setQueryData<Prescription[]>([QueryKeys.prescription], (prev) => {
                return prev?.filter(el => el.id !== Number(id)) || [];
            });
        },
    });
}